<template>
  <div class="singerinfo">
    <div class="row info-1">
      <img :src="singerDetail.thumbnail != '' ? singerDetail.thumbnail : defaultThumbnail" class="float-left mr-3"/>
      <div>
        <h4 class="text-left font-weight-bold font-size-22">{{ singerDetail.name }}</h4>
        <h4 class="text-left font-size-16 font-weight-normal">Tên khác: {{ singerDetail.otherName != "" ? singerDetail.otherName : "Đang cập nhật" }}</h4>
        <h4 class="text-left font-size-16 font-weight-normal">Ngày sinh: Đang cập nhật</h4>
        <h4 class="text-left font-size-16 font-weight-normal">Quê Quán: Đang cập nhật</h4>
        <h4 class="text-left font-size-16 font-weight-normal">Quốc gia: Đang cập nhật</h4>
      </div>
    </div>

    <div class="row info-2 mt-4">
      <div class="col-md-6 float-left">
        <div class="comp-title">
          <div class="left">
            <h1 class="text-uppercase color-text-bold">
              <img src="../../../../static/img/comp-title.png"/>
              Tiểu sử
            </h1>
          </div>
        </div>
        <div style="clear:both;"></div>

        <div class="text-justify">
          <a href="#show" class="show" id="show">Xem toàn bộ <span class="fa fa-angle-double-down"></span></a>
          <a href="#hide" class="hide" id="hide">Thu gọn <span class="fa fa-angle-double-up"></span></a>
          <div class="description" v-html="singerDetail.description"></div>
        </div>
      </div>

      <div class="col-md-6 float-right right-songlist">
        <div class="comp-title">
          <div class="left">
            <h1 class="text-uppercase color-text-bold">
              <img src="../../../../static/img/comp-title.png"/>
              Bài hát hot
            </h1>
          </div>
        </div>
        <div style="clear: both"></div>

        <div v-for="item in songList" class="row item">
          <div class="col-md-6 float-left text-left">
            <a :href="prefixUrl + item.id + '/' + convertToAlias(item.song)"><h4 class="song color-text">{{ item.song }}</h4></a>
          </div>
          <div class="col-md-3 float-left"><span class="color-text font-weight-bold codesong">Mã: {{ item.code }}</span></div>
          <div class="col-md-3 float-right text-right">
            <a @click="item.RingBackTone != '' ? showModal(downloadAlert.replace('songcode', item.RingBackTone)) : showModal(settings.installRingbacktoneAlert)">
              <span class="fa fa-download color-text font-size-18 pl-2 pr-2"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SingerInfo",
    data () {
      return {
        singerCode: "",
        singerDetail: {},
        defaultThumbnail: this.settings.defaultThumbnailSong,

        songList: [],
        prefixUrl: this.settings.prefixSong,
        downloadAlert: this.settings.downloadAlert,
      }
    },
    created () {
      this.singerCode = this.$route.params.code;
    },
    methods: {
      getSingerDetail(){
        axios.post(api.singerDetail, { id: this.$route.params.code })
          .then(response => {
            var res = response.data.result;
            this.singerDetail = res[0];
          })
          .then(response => {
            if($(".description").height() < 210){
              $(".show").hide();
            } else {
              $(".show").show();
            }
          })
          .catch(e => {
            console.log("SingerDetail-----");
            console.log(e);
          });
      },
      getSongList(){
        axios.post(api.songListRandomBySinger, { "singerCode": this.$route.params.code, "pageSize": 5 })
          .then(response => {
            this.songList = response.data.result;
            return;
          })
          .catch(e => {
            console.log("GetRandomSongList------");
          });
      },
      showModal(message){
        this.$emit("modalMessage", message);
        this.modalShow();
      }
    },
    watch: {
      "$route.path": {
        handler: function (val) {
          this.getSingerDetail();
          this.getSongList();
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .info-1 img{
    width: 150px;
    height: 150px;
    border-radius: 50%;
  }
  .item{
    min-height: 45px;
  }
  .codesong{
    background-color: #cccccc;
    padding: 0.5rem;
    border-radius: 30px;
    font-size: 14px;
    display: inline-block;
    width: 150px;
    position: relative;
    top: -0.3rem;
  }
  .right-songlist{
    height: 280px;
    background-color: #eee;
  }
  .description {
    position: relative;
    max-height: 210px;
    overflow: hidden;
    -webkit-transition: max-height .5s ease;
    transition: max-height .5s ease;
    margin-bottom: 2rem;
  }
  .show, .hide {
    position: absolute;
    bottom: 0rem;
    z-index: 100;
    text-align: center;
  }
  .hide {
    display: none;
  }
  .show:target {
    display: none;
  }
  .show:target ~ .hide {
    display: block;
  }
  .show:target ~ .description {
    max-height: 2000px;
  }
</style>



// WEBPACK FOOTER //
// src/components/singerdetail/web/Info.vue